import React from 'react';
import HomeOwnerPoll from "../../../components/pages/grid/HomeOwnerPoll/HomeOwnerPoll";

const HomeOwnerPollGridPage = () => {
    return <HomeOwnerPoll />
};

export default HomeOwnerPollGridPage;
